import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueCarousel from 'vue-carousel'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faEnvelope, faPhone} from '@fortawesome/free-solid-svg-icons'
import {faSkype, faInstagram, faTwitter, faSlack} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import Hello from './components/Hello'
import About from './components/About'
import Products from './components/Products'
import Services from './components/Services'
import Thirty from './components/30by30'
import GetStarted from './components/GetStarted'
import Ino from './components/InoMagazine'
Vue.use(VueRouter)
Vue.use(VueCarousel)

library.add(faTwitter, faInstagram, faSkype, faEnvelope, faPhone, faSlack)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
const routes = [{
  path: '/',
  component: Hello,
  meta: {
    title: 'Jancarus',
    metaTags: [{
      name: 'description',
      content: 'We collaborate to create sustainable growth in your future.'
    }]
  }
},
{
  path: '/about',
  component: About,
  meta: {
    title: 'About Jancarus',
    metaTags: [{
      name: 'description',
      content: 'Learn more about Jancarus and our expertise to help you grow to your future.'
    }]
  }
},
{
  path: '/services',
  component: Services,
  meta: {
    title: 'Services by Jancarus',
    metaTags: [{
      name: 'description',
      content: " We're a consulting company. Find which service best suits you."
    }]
  }
},
{
  path: '/products',
  component: Products,
  meta: {
    title: 'Products by Jancarus',
    metaTags: [{
      name: 'description',
      content: 'Our exclusive magazine and apparel are available here.'
    }]
  }
},
{
  path: '/products/30by30',
  component: Thirty

},
{
  path: '/products/inomagazine',
  component: Ino,
  meta: {
    title: 'INO Magazine',
    metaTags: [{
      name: 'description',
      content: 'Read our online magazine including articles on learning, management, and recipes.'
    }]
  }

},
{
  path: '/getstarted',
  component: GetStarted,
  meta: {
    title: 'Contact Jancarus',
    metaTags: [{
      name: 'description',
      content: 'Sign up and get in touch with us.'
    }]
  }
}
]

const router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'extra-active'
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title

  next()
})
new Vue({
  el: '#vue_wp_app',
  template: '<App/>',
  components: {
    App
  },
  data: {
    show: true

  },

  render: h => h(App),
  router

}).$mount('#vue_wp_app')



// WEBPACK FOOTER //
// ./src/main.js